<template>
  <b-row>
    <b-col v-if="doc" sm="12">
      <!-- <b-card>
        <b-img
          v-bind="mainProps"
          center
          v-bind:src="'data:image/jpeg;base64,'+doc.imgBase64"
          alt="Img Avatar"
          v-on:click="openImgNewTab(doc.imgBase64, doc._id)"
        ></b-img>
        <div v-if="!preventDelete" class="text-center" slot="footer">
          <b-button v-on:click="deleteDoc(doc._id)" variant="danger" class="btn-sm">ลบ</b-button>
        </div>
      </b-card>-->
      <div>
        <b-img class="uploaded-logo"
          v-bind="mainProps"
          center
          v-bind:src="'data:image/jpeg;base64,'+doc.imgBase64"
          alt="Img Avatar"
          v-on:click="openImgNewTab(doc.imgBase64, doc._id)"
        ></b-img>
      </div>
    </b-col>
    <b-col v-if="!doc">
      <div>
        <b-img class="uploaded-logo"
          v-bind="mainProps"
          center
          src="/img/icon/No_image.png"
          alt="Img Avatar"
        ></b-img>
      </div>
    </b-col>

    <b-modal
      scrollable
      :id="'doc-img-modal-' + docType"
      title="รูปภาพเอกสาร"
      hide-footer
      size="lg"
      centered
    >
      <b-img
        v-if="modalImgData"
        thumbnail
        v-bind="{ class: 'w-50' }"
        v-bind:src="'data:image/jpeg;base64,'+ modalImgData"
        center
      ></b-img>
      <div class="text-center mt-2">
        <a :href="'data:image/jpeg;base64,'+ modalImgData" :download="modalImgId + '.jpg'">ดาวน์โหลด</a>
      </div>
    </b-modal>
  </b-row>
</template>

<style>
.uploaded-logo {
  width: 200px !important;
  height: 200px !important;
}
</style>

<script>
import HttpDoc from '../services/http/Doc'

export default {
  name: 'DocLogo',
  props: ['docType', 'preventDelete', 'refId'],
  data () {
    return {
      mainProps: { class: 'w-50' },
      doc: null,
      modalImgData: '',
      modalImgId: ''
    }
  },
  async mounted () {
    this.init()
    Window.Event.$on('reloadDoc-' + this.docType, this.init)
  },
  beforeDestroy () {
    Window.Event.$off('reloadDoc-' + this.docType)
  },
  methods: {
    async init () {
      var httpDoc = new HttpDoc(this.docType, this.refId)
      var docResponse = await httpDoc.getOneLogo()
      if (docResponse.code === 1) {
        this.doc = docResponse.data
      } else if (docResponse.code === 12008) {
        this.doc = null
      } else {
        alert('โปรดติดต่อผู้ดูแลระบบ')
      }
    },
    async deleteDoc (docId) {
      var httpDoc = new HttpDoc(this.docType, this.refId)
      var deleteResult = await httpDoc.deleteDoc(docId)
      if (deleteResult.code == 1) {
        this.init()
      }
    },
    openImgNewTab (data, id) {
      // var image = new Image();
      // image.src = "data:image/jpg;base64," + data
      this.modalImgData = data
      this.modalImgId = id
      // var w = window.open("")
      // w.document.write(image.outerHTML)
      this.$bvModal.show('doc-img-modal-' + this.docType)
    },
    async openPdfNewTab (docId) {
      var httpDoc = new HttpDoc(this.docType, this.refId)
      try {
        var pdf = await httpDoc.getPdfDoc(docId)
      } catch (error) {
        alert('ไม่พบเอกสาร')
        return
      }
      var fileURL = URL.createObjectURL(pdf)
      window.open(fileURL, '')
    }
  }
}
</script>
